import React from "react";

import { Tooltip } from "components";
import lang from "translations";

const NoticeEditTooltip = ({ children }) => {
  const content = (
    <div className="text-xs text-gray-disabled">
      {lang.productHasVariantsEditPriceInDetail}
    </div>
  );

  return (
    <Tooltip title={content} arrowPointAtCenter placement="top" color="#46B0C6" trigger="click">
      {children}
    </Tooltip>
  );
};

export default NoticeEditTooltip;
